module.exports = __webpack_public_path__ + "static/img/3.228485f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Responsabilidad-civil-danos-terceros/3.png
// module id = a9ZC
// module chunks = 0